var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "el-fade-in" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible && !_vm.isLiked,
            expression: "visible && !isLiked",
          },
        ],
        staticClass: "hover-modal",
        on: {
          click: function ($event) {
            if ($event.target !== $event.currentTarget) {
              return null
            }
            _vm.visible = false
          },
        },
      },
      [
        _c("div", { staticClass: "hover-dialog" }, [
          _c(
            "div",
            {
              staticStyle: {
                height: "98vh",
                width: "168px",
                "overflow-y": "auto",
                "overflow-x": "hidden",
              },
            },
            [
              _c(
                "p",
                {
                  staticClass: "el-icon",
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_c("i", { staticClass: "el-icon-close" })]
              ),
              _vm._l(_vm.item, function (child, i) {
                return _c(
                  "div",
                  { key: child.name + i, staticClass: "hover-content" },
                  [
                    !(
                      child.children &&
                      Array.isArray(child.children) &&
                      child.children.filter(function (e) {
                        return !e.hidden
                      }).length
                    )
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "title-item hover",
                              attrs: { title: _vm.generateTitle(child.name) },
                            },
                            [
                              child.meta
                                ? _c("Item", {
                                    attrs: {
                                      "right-icon": _vm.isLike(child.name)
                                        ? "el-icon-star-on"
                                        : "el-icon-star-off",
                                      title: _vm.generateTitle(child.name),
                                    },
                                    on: {
                                      titleClick: function ($event) {
                                        return _vm.toRoute(child)
                                      },
                                      iconClick: function ($event) {
                                        return _vm.handleClickIcon(child)
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              }),
            ],
            2
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }